/* eslint-disable */
import cx from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux'
import './OzPills.css'

class OzPills extends Component {

  state = {};

  handleClick(idx) {
    console.log('idx', idx);
    if (this.props.onClick) {
      this.props.onClick(idx);
    }
  }

  render() {
    let i = 0;
    let nodes = this.props.children.map(child => {
      let active = this.props.value == child.key;
      console.log('debug pills 123', child.props);
      let idx = i;
      i++;
      console.log('idx??', idx);
      return (
        <div key={idx} className={cx('oz-pill', { active })} onClick={() => this.handleClick(idx)}>
          {child}
        </div>
      );
    });
    return (
      <div className={cx('OzPills', this.props.size || '')}>
        <div className="oz-pills">{nodes}</div>
      </div>
    );
  }
}

export default OzPills;



/** WEBPACK FOOTER **
 ** ./src/components/partials/OzPills.js
 **/